import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Panel from '@spothero/ui/panel';
import HowToRedeem from '../redeem/HowToRedeem';

const HowToRedeemArrivalDeparture = ({facility}) => {
    const {
        airport: {redemption_instructions: instructions},
    } = facility;
    const classes = classNames(
        'SpotDetails-section',
        'HowToRedeemArrivalDeparture'
    );

    return (
        <div className={classes}>
            <h4 className="subtitle">How To Redeem</h4>
            <p>
                You will receive an email with redemption instructions after
                making a reservation.
            </p>
            <Panel title="Show redemption instructions" showTitleToggle>
                <HowToRedeem
                    sectionTitle="Arrival"
                    instructions={instructions?.arrival}
                />
                <HowToRedeem
                    sectionTitle="Departure"
                    instructions={instructions?.departure}
                />
            </Panel>
        </div>
    );
};

HowToRedeemArrivalDeparture.propTypes = {
    facility: PropTypes.object.isRequired,
};

export default HowToRedeemArrivalDeparture;
